import { lazy, memo } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'

import pathName from './pathName.constant'
import ProtectedRoute from './PrivateRoute'
import PageNotFound from '../components/PageNotFound'
import UserManagement from '../components/userManagement/presentation'

const AppLayout = lazy(
  () => import('../components/layout/presentation/AppLayout'),
)
const Dashboard = lazy(() => import('../components/dashboard/presentation'))
const Auth = lazy(() => import('../components/layout/presentation'))
const Installation = lazy(
  () => import('../components/jobs/presentation/addJobs/installation'),
)
const Home = lazy(() => import('../components/home/presentation'))
const DataVisualization = lazy(
  () => import('../components/dataVisualization/presentation'),
)
const AuthAddUser = lazy(
  () => import('../components/userManagement/presentation/AuthAddUser'),
)
const Profile = lazy(() => import('../components/profile/presentation/index'))
const CatalogueManagement = lazy(
  () => import('../components/catalogueManagement/presentation'),
)
const AddCatalogue = lazy(
  () => import('../components/catalogueManagement/presentation/AddCatalogue'),
)
const JobManagement = lazy(() => import('../components/jobs/presentation'))
const Repair = lazy(
  () => import('../components/jobs/presentation/addJobs/Repair'),
)
const AddEditJobs = lazy(
  () => import('../components/jobs/presentation/addJobs'),
)

const Routing = () => {
  const routes = useRoutes([
    {
      path: pathName.ROOT,
      element: (
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <Navigate to={pathName.HOME} replace={true} />,
        },
        {
          path: pathName.HOME,
          element: <Home />,
        },
        {
          path: pathName.DASHBOARD,
          element: <Dashboard />,
        },
        {
          path: pathName.USER,
          element: <UserManagement />,
        },
        {
          path: pathName.DATA_VISUALIZATION,
          element: <DataVisualization />,
        },
        {
          path: pathName.ADD_USER,
          element: <AuthAddUser />,
        },
        {
          path: pathName.PROFILE,
          element: <Profile />,
        },
        {
          path: pathName.CATALOGUE,
          element: <CatalogueManagement />,
        },
        {
          path: pathName.ADD_CATALOGUE,
          element: <AddCatalogue />,
        },
        {
          path: pathName.JOBS,
          element: <JobManagement />,
        },
        {
          path: pathName.ADD_REPAIR,
          element: <Repair />,
        },
        {
          path: pathName.ADD_INSTALLATION,
          element: <Installation />,
        },
        {
          path: pathName.EDIT_INSTALLATION,
          element: <Installation isEdit={true} />,
        },
        {
          path: pathName.EDIT_REPAIR,
          element: <Repair />,
        },
        {
          path: pathName.ADD_JOB,
          element: <AddEditJobs />,
        },
        {
          path: pathName.EDIT_JOB,
          element: <AddEditJobs />,
        },
        { path: '*', element: <PageNotFound /> },
      ],
    },
    { path: pathName.LOGIN, element: <Auth /> },
    { path: pathName.FORGOT_PASSWORD, element: <Auth /> },
  ])

  return routes
}

export default memo(Routing)
